export default __webpack_public_path__ + "static/gold-f1eb3b3ced7758c6b6c8b6c51d9a14dd.png";